module.exports = __webpack_public_path__ + "static/media/Himanshu.4afb89a5.jpg";